var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowupicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1558_2262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.627 0 24 5.37298 24 12C24 18.6263 18.627 24 12 24C5.37298 24 0 18.6269 0 12C0 5.37306 5.37221 0 12 0Z",
    fill: "#E2574C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74932 9.7522H9.76059V6.74925C9.76059 6.33529 10.0959 5.99924 10.5098 5.99924H13.5068C13.9201 5.99924 14.2553 6.3352 14.2553 6.74925V9.75152H17.2508C17.3493 9.75143 17.4468 9.77077 17.5379 9.80843C17.6289 9.84609 17.7116 9.90133 17.7813 9.97099C17.851 10.0407 17.9062 10.1234 17.9439 10.2144C17.9815 10.3054 18.0009 10.403 18.0008 10.5015V13.5023C18.0008 13.9178 17.6655 14.2537 17.2508 14.2537H14.2553V17.2477C14.2553 17.6624 13.92 17.9977 13.5068 17.9977H10.5098C10.0959 17.9977 9.76059 17.6624 9.76059 17.2477V14.2537H6.74932C6.33459 14.2537 5.99854 13.9178 5.99854 13.5023V10.5015C5.99854 10.0875 6.33459 9.7522 6.74932 9.7522Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1558_2262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowupicon);
export default __webpack_public_path__ + "static/media/followupicon.ee75d19528d4f9ac2c8237830167c994.svg";
export { ForwardRef as ReactComponent };